import { createContext, useContext, useEffect, useState, useCallback } from 'react'
import { apiRequest, tokenStore } from '../api/client'

const AuthContext = createContext(null)

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)

  const refresh = useCallback(async () => {
    if (!tokenStore.get()) {
      setUser(null)
      setLoading(false)
      return
    }
    try {
      const { user } = await apiRequest('/api/v1/me')
      setUser(user)
    } catch {
      tokenStore.clear()
      setUser(null)
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => { refresh() }, [refresh])

  const logout = async () => {
    try { await apiRequest('/api/v1/logout', { method: 'DELETE' }) } catch {}
    tokenStore.clear()
    setUser(null)
  }

  const setTokenAndRefresh = async (token) => {
    tokenStore.set(token)
    await refresh()
  }

  return (
    <AuthContext.Provider value={{ user, loading, logout, setTokenAndRefresh }}>
      {children}
    </AuthContext.Provider>
  )
}

export const useAuth = () => useContext(AuthContext)
